import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { API_URL } from "config";
import { FILTER_OPERATIONS, QueryBuilder } from "features/members";
import fileDownload from "js-file-download";
import moment from "moment";
import { useCentralStore } from "stores";
import { getToken } from "utils/getToken";

const exportTrialBalance = async ({
  churchId,
  format = "xlsx",
  orientation = "portrait",
  queries = {}
}) => {
  const queryBuilder = new QueryBuilder();
  queryBuilder.append("format", format);
  queryBuilder.append("orientation", orientation);

  if (queries.search) {
    queryBuilder.search(queries.search);
  }

  if (queries.startDate && queries.endDate) {
    queryBuilder.filter({
      updated_at: [
        {
          operator: FILTER_OPERATIONS.BETWEEN,
          value: [queries.startDate, queries.endDate]
        }
      ]
    });
  }

  const queryString = queryBuilder.build();
  const url = `${API_URL}/churches/${churchId}/trial-balance-export${queryString}`;

  const response = await axios({
    method: "get",
    url: url,
    responseType: "blob",
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  });

  return response.data;
};

export const useExportTrialBalance = () => {
  const setNotification = useCentralStore(state => state.setNotification);

  return useMutation({
    mutationFn: exportTrialBalance,
    onSuccess: (data, { format = "xlsx" }) => {
      fileDownload(
        new Blob([data]),
        `trial-balance-${moment().format("DD-MM-YYYY-hh-mm-A")}.${format}`
      );
      setNotification({
        type: "success",
        message: "Trial balance exported successfully"
      });
    },
    onError: () => {
      setNotification({
        type: "error",
        message: "Unable to export trial balance"
      });
    }
  });
};
